/**
 * Mock Aruba firmware versions — small variety so the picker has options
 * across both switches and APs.
 */
import type { ArubaFirmware } from "@/api/schemas/aruba";

export const MOCK_ARUBA_FIRMWARE: ArubaFirmware[] = [
  { version: "AOS-CX 10.13.1010", appliesTo: ["CX-6300", "CX-6200"], releasedAt: "2026-03-15", recommended: true,  highlights: ["Fix BPDU storm under heavy port-flap", "REST API perf +35%"] },
  { version: "AOS-CX 10.13.1005", appliesTo: ["CX-6300", "CX-6200"], releasedAt: "2026-02-01", recommended: false, highlights: ["Cut by GuestTek due to multicast snooping regression"] },
  { version: "AOS-10 10.5.1.0",   appliesTo: ["AP-655", "AP-635"],   releasedAt: "2026-04-02", recommended: true,  highlights: ["Wi-Fi 7 cert pickup", "Roaming improvements"] },
  { version: "AOS-10 10.5.0.5",   appliesTo: ["AP-655", "AP-635"],   releasedAt: "2026-01-19", recommended: false, highlights: ["Older — keep only if you're rolling back"] },
];
